import { useTheme } from '@fluentui/react/lib/Theme';
import { IPMessageBar, IPText } from 'baseComponents';
import { ReactNode } from 'react';
import { IPMessageBarType } from "baseComponents/MessageBar/IPMessageBar";

interface IWarningMessageProps {
  message?: string;
  onDismiss?: () => void;
  children?: ReactNode;
}

const WarningMessage = (props: IWarningMessageProps) => {
  // The theme's message ink for the text, not black: black vanishes on the dark warning tint.
  const theme = useTheme();
  if (props.message === undefined && props.children === undefined) {
    return null;
  }

  return (
    <IPMessageBar
      messageBarType={IPMessageBarType.warning}
      onDismiss={props.onDismiss}
      isMultiline={true}
      truncated={false}
    >
      {props.message && (
        <IPText styles={{ root: { color: theme.semanticColors.messageText } }} block>
          {props.message}
        </IPText>
      )}
      {props.children}
    </IPMessageBar>
  );
};

export default WarningMessage;
